export default __webpack_public_path__ + "static/media/PrintedMaterial4.bb530554.png";